import { Injectable } from '@angular/core';

@Injectable()
export class UtilsStringService {
    static isUndefined(s: string) {
        return s === undefined;
    }

    static isNull(s: string) {
        if (s !== undefined) {
            return s === null;
        }
        return false;
    }

    static isEmpty(s: string) {
        if (s !== undefined && s !== null) {
            return s.length === 0;
        }
        return false;
    }

    isUndefinedOrNullOrEmpty(s: string) {
        return (
            UtilsStringService.isUndefined(s) ||
            UtilsStringService.isNull(s) ||
            UtilsStringService.isEmpty(s)
        );
    }
    private _stringArrayUndefinedOrNullOrEmpty(arr: string[]) {
        return arr.map(s => this.isUndefinedOrNullOrEmpty(s));
    }
    allUndefinedOrNullOrEmpty(arr: string[]) {
        return this._stringArrayUndefinedOrNullOrEmpty(arr).reduce(
            (prev, curr, index, array) => prev === true && curr === true
        );
    }
    anyUndefinedOrNullOrEmpty(arr: string[]) {
        return this._stringArrayUndefinedOrNullOrEmpty(arr).reduce(
            (prev, curr, index, array) => prev === true || curr === true
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/helpers/utils-string.service.ts